module.exports = __webpack_public_path__ + "img/电器-产品商品条码标识.1a5c1563.jpg";